import { useRequiredContext } from "@redotech/react-util/context";
import CodeBrowserIcon from "@redotech/redo-icons/code-browser.svg";
import CodeBrowserFilledIcon from "@redotech/redo-icons/code-browser_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { isAdvancedCheckoutFeaturesAvailable } from "@redotech/redo-model/conversion/features";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const WidgetsItems = memo(function WidgetsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const isAvailable = isAdvancedCheckoutFeaturesAvailable({
    hasShopifyPlus: !!team.shopifyIntegration?.hasShopifyPlus,
    planDisplayName: team.shopifyIntegration?.planDisplayName,
    teamId: team._id,
  });

  if (!isAvailable) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getConversionSubRoute("widgets"),
      }}
      FilledIcon={CodeBrowserFilledIcon}
      friendlyName="Widgets"
      id="widgets"
      UnfilledIcon={CodeBrowserIcon}
    />
  );
});
